import React from "react";
import logo from "../media/logo.svg";

const phrases = [
  "Нарезаем ингредиенты",
  "Проверяем рецепт",
  "Разогреваем сковороду",
  "Добавляем щепотку магии",
  "Пробуем на вкус",
  "Перемешиваем до идеала",
  "Готовим фирменный штрих",
  "Следим, чтобы не пригорело",
  "Доводим до кондиции",
  "Собираем блюдо",
  "Украшаем подачу",
  "Проверяем баланс вкуса",
  "Добавляем финальный акцент",
  "Снимаем с огня",
  "Даём немного настояться",
  "Режем аккуратно, не спеша",
  "Подрумяниваем края",
  "Держим температуру",
  "Контролируем тайминг",
  "Делаем как для себя",
  "Секунда — и будет готово",
  "Наводим кулинарный порядок",
  "Проверяем текстуру",
  "Соблюдаем пропорции",
  "Фиксируем результат",
  "Подаём горячим",
  "Добавляем настроение",
  "Готово почти идеально",
  "Последний штрих",
  "Можно подавать"
];

const cookingScenes = [
  { key: "boil", label: "Варится", hint: "Кастрюля шепчет на огне" },
  { key: "fry", label: "Жарится", hint: "Сковородка шипит и крутится" },
  { key: "bake", label: "Запекается", hint: "Духовка держит жар" },
  { key: "chop", label: "Режется", hint: "Нож ловко работает" },
];

const Preloader = () => {
  const [phraseIndex, setPhraseIndex] = React.useState(0);
  const [sceneIndex, setSceneIndex] = React.useState(() =>
    cookingScenes.length ? Math.floor(Math.random() * cookingScenes.length) : 0
  );

  React.useEffect(() => {
    const timer = setInterval(
      () => setPhraseIndex((prev) => (prev + 1) % phrases.length),
      1400
    );

    return () => clearInterval(timer);
  }, []);

  React.useEffect(() => {
    const timer = setInterval(() => {
      setSceneIndex((prev) => {
        if (cookingScenes.length < 2) return prev;
        let next = prev;
        while (next === prev) {
          next = Math.floor(Math.random() * cookingScenes.length);
        }
        return next;
      });
    }, 1500);

    return () => clearInterval(timer);
  }, []);

  const activeScene = cookingScenes[sceneIndex];

  const renderScene = () => {
    switch (activeScene.key) {
      case "boil":
        return (
          <div className="scene-boil">
            <div className="pot">
              <span className="pot-lid" />
              <span className="pot-body" />
              <span className="pot-handle pot-handle-left" />
              <span className="pot-handle pot-handle-right" />
              <span className="pot-steam steam-one" />
              <span className="pot-steam steam-two" />
              <span className="pot-steam steam-three" />
            </div>
            <div className="cook-fire">
              <span className="flame flame-one" />
              <span className="flame flame-two" />
              <span className="flame flame-three" />
            </div>
          </div>
        );
      case "fry":
        return (
          <div className="scene-fry">
            <div className="pan">
              <span className="pan-inner" />
              <span className="pan-egg" />
            </div>
            <div className="pan-handle" />
            <div className="cook-fire">
              <span className="flame flame-one" />
              <span className="flame flame-two" />
              <span className="flame flame-three" />
            </div>
          </div>
        );
      case "bake":
        return (
          <div className="scene-bake">
            <div className="oven">
              <span className="oven-vent vent-left" />
              <span className="oven-vent vent-right" />
              <span className="oven-knob knob-one" />
              <span className="oven-knob knob-two" />
              <span className="oven-knob knob-three" />
              <span className="oven-window" />
              <span className="oven-glow" />
              <span className="oven-tray" />
              <span className="oven-pie" />
              <span className="oven-heat heat-one" />
              <span className="oven-heat heat-two" />
            </div>
          </div>
        );
      case "chop":
      default:
        return (
          <div className="scene-chop">
            <div className="board" />
            <div className="veg veg-tomato">
              <span className="veg-body" />
              <span className="veg-slice" />
            </div>
            <div className="veg veg-cucumber">
              <span className="veg-body" />
              <span className="veg-slice" />
            </div>
            <div className="knife">
              <span className="knife-blade" />
              <span className="knife-handle" />
            </div>
            <span className="chop-chip chip-one" />
            <span className="chop-chip chip-two" />
          </div>
        );
    }
  };

  return (
    <div className="app-preloader" role="status" aria-live="polite">
      <div className="preloader-gradient" />
      <div className="preloader-aurora" />
      <div className="preloader-aurora aurora-alt" />
      <div className="preloader-noise" />

        <div className="preloader-card">
        <div className="preloader-hero">
          <div className="preloader-logo">
            <span className="preloader-glow" />
            <img src={logo} alt="Логотип" />
          </div>

          <div className="cook-stage">
            <div className="cook-scene">{renderScene()}</div>
          </div>
        </div>

        <p className="preloader-subtitle hero-subtitle">{phrases[phraseIndex]}</p>
      </div>
    </div>
  );
};

export default Preloader;
